// ticket-content-sha256.ts
//
// Security audit G2+G3 H-1: the content a controller op wrote, pinned in its
// journal intent (`params.ticket_sha256`). Ticket files are read back from a
// worktree a worker also writes, so "same id + same shape" is not proof the
// controller wrote THIS content — the hash is. Canonical form: the schema-
// parsed ticket (schema key order, unknown keys dropped) as compact JSON, so
// the object built before writing and the one parsed back from disk agree.
import { createHash } from "node:crypto";
import { type Ticket, TicketSchema } from "./schemas/ticket-schema.js";

export function ticketContentSha256(ticket: Ticket): string {
  return createHash("sha256")
    .update(JSON.stringify(TicketSchema.parse(ticket)))
    .digest("hex");
}
